import ApolloClient from 'apollo-boost';
import Cookies from 'js-cookie';
import store from '@/store';
import { getMbtiUrl } from '@/utils/urlHelper';

const apolloClient = new ApolloClient({
  uri: () => getMbtiUrl() + '/graphql',
  request: operation => {
    const token = Cookies.get('mystage_student_token') || store.state.bizmates_token || Cookies.get('bizmates_token') || null;
    operation.setContext({
      headers: {
        authorization: 'Bearer ' + token,
      },
    });
  },
});

export {
  apolloClient
};
